require('./menu-items/menu-items.scss');
var BaseViews = require('../../common/base');
var NoMenuItems = BaseViews.ItemView.extend({
    className: 'fmcy-menu-items-no-menu-items',
    collectionEvents: {
        'fetch:start': 'render',
        'fetch:end': 'render'
    },
    template: function() {
        return 'No products match your search criteria. Please review search filters.';
    },
    onRender: function () {
        if (this.options.isFetching()) {
            this.$el.hide();
        } else {
            this.$el.show();
        }
    }
});


var MenuItemThumb = require('./common/menu-item-thumb');

var MenuItems = Marionette.CollectionView.extend({
    className: 'fmcy-menu-items row-flex clearfix',
    emptyView: NoMenuItems,
    childView: MenuItemThumb,
    childEvents: {
        'thumb:clicked': 'onChildThumbClicked'
    },
    onChildThumbClicked: function(childView) {
        this.trigger('thumb:clicked', childView.model);
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                showProductLocations: false,
                showOnlineProductLocations: false,
                _menuState: null,
                shouldEnableOnlinePurhaseCallback: function (menuItem) {
                    return false;
                }
            }
        );
    },
    emptyViewOptions: function (model, index) {
        return {
            collection: this.options.collection,
            isFetching: this.options.isFetching
        };
    },
    childViewOptions: function(model, index) {
        return {
            locations: this.options.locations,
            thumbStyle: this.options.thumbStyle,
            collection: this.options.collection,
            _menuState: this.options._menuState,
            isFetching: this.options.isFetching,
            extraClassName: this.options.thumbStyle === 'full' ?
                'col-flex-xs-12' :
                'col-flex-xs-12 col-flex-sm-6 col-flex-md-4 col-flex-xl-3',
            appChannel: this.options.appChannel,
            displayImageURL: this.options.getItemDisplayImageURL(model),
            onlinePurchaseEnabled: this.options.shouldEnableOnlinePurhaseCallback(model),
            showProductLocations: _.result(this.options, 'showProductLocations'),
            locationSwitchingEnabled: this.options.locationSwitchingEnabled,
            showOnlineProductLocations: this.options.showOnlineProductLocations,
            bannerPriority: _.result(this.options, 'bannerPriority'),
            menuItemPriceLayoutSinglePrice: 'promotion'
        };
    },
    _onWindowResize: function (event) {
      if ($(window).height() < 1920) {
        this.$el.css('min-height', $(window).height() - 200);
      }
    },
    onRender: function() {
      var self = this;

      this.$el.addClass(this.options.thumbStyle);
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});
module.exports = MenuItems;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-items.js
 **/